import { Box } from "@mui/material";
import styles from "./WelcomeOverviewCarousel.module.scss";
import CustomSkeleton from "../../components/custom-skeleton/CustomSkeleton";

const WelcomeOverviewSkeleton = () => {

  return (
    <Box className={styles.swiperContainer} sx={{
      top: {
        xs: "9.81rem",
        sm: "9.81rem",
        md: "7.81rem",
      },
    }}>
      <Box className={styles.slideView}>
        {/* Image skeleton */}
        <Box className={styles.imageBox}>
          <CustomSkeleton
            variant="circular"
            width="12.5rem"
            height="12.5rem"
          />
        </Box>

        {/* Title skeleton */}
        <CustomSkeleton
          variant="text"
          width="60%"
          height={40}
          sx={{
            marginTop: {
              xs: "9rem",
              sm: "9rem",
              md: "1rem",
            },
          }}
        />

        {/* Content skeleton */}
        <CustomSkeleton variant="text" width="90%" height={20} />
        <CustomSkeleton variant="text" width="85%" height={20} />
        <CustomSkeleton variant="text" width="70%" height={20} />
      </Box>
    </Box>
  );
};

export default WelcomeOverviewSkeleton;
